<template>
  <div>
    <flash-messages/>
    <div class="px-4 py-2 bg-gray-700">
      <img src="/images/logo.png" class="h-12 mx-auto" alt="Casa Auto">
    </div>

    <div class="p-2">
      <div class="mb-2" v-if="mediaFiles.length">
        <div v-for="media in mediaFiles" :key="media.id" class="mb-2">
          <img v-if="media.collection_name === 'images'" :src="media.url" alt="" class="object-contain w-full h-56 bg-black"/>
          <video v-if="media.collection_name === 'videos'" class="object-contain w-full h-56 bg-black" controls>
            <source :src="media.url" type="video/webm">
            <source :src="media.url_mp4" type="video/mp4">
          </video>
        </div>
      </div>
    </div>

    <div class="p-2">
      <div class="p-4 mb-6 bg-white rounded shadow" v-if="request.content">
        <p>{{ request.content }}</p>
      </div>

      <div class="p-4 bg-white rounded shadow">
        <h2 class="mb-4 text-xl font-semibold text-center text-gray-700">Acorda-ne o nota</h2>
        <div class="flex -mx-2">
          <button v-for="(star, index) in stars" :key="index" @click="rate(index +1)" class="w-1/5 mx-2">
            <icon :name="star.filled ? 'star-filled' : 'star'" class="w-full h-full text-yellow-500"></icon>
          </button>
        </div>
      </div>
    </div>

  </div>
</template>


<script>
  import Icon from '@/Shared/Icon';
  import FlashMessages from "@/Shared/FlashMessages";

  export default {
    metaInfo() {
      return {
        title: this.__('Job :id notifications', {id: this.job.id}),
      }
    },
    props: {
      job: Object,
      request: Object,
    },
    data() {
      return {
        stars: [{filled: false}, {filled: false}, {filled: false}, {filled: false}, {filled: false}],
        mediaFiles: [],
      }
    },
    components: {
      Icon,
      FlashMessages
    },
    mounted() {
      this.mediaFiles = this.request.media;
      this.setRating(this.job.rating);
    },
    methods: {
      rate(rating) {
        this.setRating(rating);
        this.$inertia.put(this.route('ratings.update', {jobUuid: this.job.uuid}), {rating: rating});
      },
      setRating(rate) {
        this.stars.map((star, index) => star.filled = index < rate);
      }
    },
  }
</script>
